import { SET_COMPANIES_FILTERS } from '../actions/filters';
const initialState = {
    name: '',
    identifier: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_COMPANIES_FILTERS: {
            return {
                ...state,
                name: action.payload.name,
                identifier: action.payload.identifier,
            };
        }

        default:
            return state;
    }
};
